import {useState, useEffect} from "react"
import {
    handleSeoPillsImpression,
    handleVisualPillsImpression,
    setupSeoPillsEventListeners,
    setupVisualPillsEventListeners,
} from "../../utils/searchBanner"

export const useSearchBannerLoaded = url => {
    const [searchBannerTextLoaded, setSearchBannerTextLoaded] = useState(false)

    const setMobileSearchBannerText = () => {
        const searchBannerText = document.getElementById("search-banner-read-more-content")
        const mobileSearchBannerText = document.getElementById("search-banner-mobile-read-more-content")
        if (searchBannerText && mobileSearchBannerText) {
            mobileSearchBannerText.innerHTML = searchBannerText.innerHTML
            setSearchBannerTextLoaded(true)
        }
    }

    useEffect(() => {
        const hasSearchBannerTextLoaded = () => {
            const searchBannerText = document.getElementById("search-banner-read-more-content")

            if (!searchBannerText) {
                setSearchBannerTextLoaded(false)
            } else {
                setMobileSearchBannerText()
            }

            handleVisualPillsImpression(document)
            handleSeoPillsImpression(document)

            setupSeoPillsEventListeners(document)
            setupVisualPillsEventListeners(document)
        }
        hasSearchBannerTextLoaded()
    }, [url])

    return searchBannerTextLoaded
}
